import { actions } from '../actions';

const initialState = { total: 0, items: [], summary: {} };

export const prsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_PRS_SUCCEED:
      return action.payload;
    case actions.GET_PRS_FAILURE:
      return Object.assign({}, initialState);
    case actions.RESET_PRS:
      return initialState;
    default:
      return state;
  }
};
